export default __webpack_public_path__ + "static/positouch-pos-cash-register-7d01f8c10bde70c9f6efec7a76a9f8e4.png";